export default "__VITE_ASSET__a33a0e4b__"